export enum ASSEMBLY_PUBLICATION_LIST_COLUMN {
  DISPLAY_NAME = 'display_name',
  NUM_ASSEMBLIES = 'numberOfAssemblies',
  FROM_COMP = 'fromComponent',
  TO_COMP = 'toComponent',
  USER = 'user',
  LAST_MODIFIED = 'modified_at',
}

export enum PUBLICATION_STATUS {
  STAGED = 'staged',
  SAVED = 'saved',
}

export interface IPublicationList {
  display_name: string;
  numberOfAssemblies: number;
  fromComponent: string;
  toComponent: string;
  user: string;
  modified_at: string;
}

export type ModalActionType = 'Delete' | 'Save';
